import styled, { css } from 'styled-components'

export const Container = styled.div`
    width: 94%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 20px;
`

export const BarData = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    color: var(--colorFontsCardsDashboard);
    font-weight: 900;
    overflow-x: hidden;

    strong{
        min-width: 30%;
        width: 30%;
        max-height: 1.8rem;
        font-size: 0.8rem;
        overflow: hidden;
        margin-right: 0.1rem;
        opacity: 0;
        transition: opacity 2s ease;

    }

    
    p{
        font-size: 0.9rem;
        opacity: 0;
        transition: opacity 2s ease;
    }

    ${props => props.animationBar && css`
        strong, p{
            opacity: 1;
        }
    `}
`

export const Bar = styled.div`
    height: 2rem;
    background: ${props => props.color ? props.color : 'var(--colorFontsCardsDashboard)'};
    margin: 0.2rem 0.2rem 0.2rem 0;
    width: 0;
    transition: width 1.5s ease;
    
    display: flex;
    align-items: center;
    justify-content: center;

    p{
        color: #FFF;
        opacity: 0;
        transition: opacity 2s ease;
    }

    ${props => props.percent && props.animationBar && css`
        width: ${props.percent * 0.70 + '%'};
        p{
            opacity: 1;
        }
    `};
`